import * as fs from 'node:fs';
import * as path from 'node:path';
import { forEachWithGitYield } from '../../git/git-runtime.js';
import type { LogFn } from '../../log.js';
import { gitRun, gitStashCreate, gitUntrackedPaths } from '../../git/snapshot/git.js';

export type WorkingTreeWipState = {
  stashSha: string;
  untrackedPaths: string[];
};

export async function captureWorkingTreeWip(repoPath: string, log: LogFn): Promise<WorkingTreeWipState> {
  const stashSha = await gitStashCreate(repoPath, log);
  const untrackedPaths = await gitUntrackedPaths(repoPath, log);
  return { stashSha, untrackedPaths };
}

export async function applyWorkingTreeWip(
  targetRepoPath: string,
  sourceRepoPath: string,
  wip: WorkingTreeWipState,
  log: LogFn,
): Promise<{ ok: boolean; error?: string }> {
  if (wip.stashSha) {
    const ap = await gitRun(targetRepoPath, ['stash', 'apply', wip.stashSha], log, 'stash apply');
    if (!ap.ok) return ap;
  }
  await forEachWithGitYield(wip.untrackedPaths, async (rel) => {
    const src = path.join(sourceRepoPath, rel);
    const dst = path.join(targetRepoPath, rel);
    try {
      if (!fs.existsSync(src)) return;
      fs.mkdirSync(path.dirname(dst), { recursive: true });
      fs.copyFileSync(src, dst);
    } catch (e) {
      log(
        `[worktrees] Failed to copy untracked ${rel}: ${e instanceof Error ? e.message : String(e)}`,
      );
    }
  });
  return { ok: true };
}
